import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { getAllCategorys } from "../../../redux/actions/categories";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class NetRevenue extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'NET_REVENUE_REPORTS',
      path: ["Home", "Net Revenue Report"],
      links: ["home", "report/netrevenue"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      dealType: '',
      merchantTypeID: '',
      totalRecords: 0,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      isLoading = "true";   
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          dealType: this.state.dealType,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          dealType: this.state.dealType,
        };
      }
      this.props.getReport(formData, 'report/netrevenue');
    } else {
      isLoading = "false";
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getAllCategorys({page:0});
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), dealType:'offer'}, 'report/netrevenue');
      }else{
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), dealType:''}, 'report/netrevenue');
      }
    }    
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ totalRecords: nextProps.reportData.total_record});
        this.setState({ reportData: nextProps.reportData});
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        isLoading = "false";
        this.setState({catData: nextProps.catData.data});
      }
    }

    if (nextProps.message) {
      isLoading = "false";
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Date',
        'Daily Gross Billings',
        'Promo Codes',
        'Store Credit',
        'Refunded',
        'Total Credit Card Sales',
      ]
    ];

    {data &&
      data.data.map((netrevData, netrevIndex) => 
        csvData.push([
          netrevData.created_on,
          netrevData.daily_gross_billing,
          netrevData.discount,
          netrevData.store_credit,
          netrevData.amount_refunded,
          netrevData.credit_card_sale,
        ])
      )
    }

    {data &&
      data.total && 
      csvData.push([
        'Total',
        data.total.daily_gross_billing , 
        data.total.discount, 
        data.total.store_credit,
        data.total.amount_refunded,
        data.total.credit_card_sale,
      ])
    }

    this.setState({ csvData: csvData });
  };

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Net Revenue Report</header>
            <div className="panel-body">
              <Row>                            
                <Col md={3} xs={12}>
                <ControlLabel>Date</ControlLabel>
                <FormGroup controlId="formOfferTitle">
                {this.state.range == false ? (
                  <DatePicker
                  onChange={this.onChangeStartDate}
                  value={this.state.startDate}
                  />
                  ) : (
                  <DateRangePicker
                  onChange={this.onChangeStartDateRange}
                  value={this.state.startDateRange}
                  />
                  )}
                </FormGroup>
                </Col> 
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                      >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>        
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                    data={this.state.csvData}
                    filename={"netrevenue-report.csv"}
                    className="btn btn-default"
                    >
                    Export CSV
                    </CSVLink>
                    ) : null}
                  {this.state.range == false ? (
                    <a
                    className="btn btn-success"
                    type="submit"
                    onClick={this.changeDatePicker}
                    id="saveButton"
                    >
                    Use Range
                    </a>
                    ) : (
                    <a
                    className="btn btn-success"
                    type="submit"
                    onClick={this.changeDatePicker}
                    id="saveButton"
                    >
                    Use Date
                    </a>
                    )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Daily Gross Billings</th>
                  <th>Promo Codes</th>
                  <th>Store Credit</th>
                  <th>Refunded</th>
                  <th>Total Credit Card Sales</th>
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                  this.state.reportData.data.map((netrevData, netrevIndex) =>
                    <tr key={netrevData.offerID + netrevIndex}>
                      <td>{netrevData.created_on}</td>
                      <td>{netrevData.daily_gross_billing}</td>
                      <td>{netrevData.discount}</td>
                      <td>{netrevData.store_credit}</td>
                      <td>{netrevData.amount_refunded}</td>
                      <td>{netrevData.credit_card_sale}</td>
                    </tr> 
                  )
                :
                <tr><td colSpan="14">Data Not Found</td></tr>
              }
              {this.state.reportData.total && 
                <tr key={Math.random()}>
                  <td colSpan="1">Total</td> 
                  <td>{this.state.reportData.total.daily_gross_billing}</td> 
                  <td>{this.state.reportData.total.discount }</td> 
                  <td>{this.state.reportData.total.store_credit}</td> 
                  <td>{this.state.reportData.total.amount_refunded }</td>
                  <td>{this.state.reportData.total.credit_card_sale }</td> 
                </tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    catData: state.categoryReducer.catData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getAllCategorys,
  })
)(NetRevenue);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/NetRevenue.js